// extracted by mini-css-extract-plugin
export default {"loadingStateWrapper":"TagsListDropdown_loadingStateWrapper__CsVgG","item":"TagsListDropdown_item__JeY+U","actionsButtonsWrapper":"TagsListDropdown_actionsButtonsWrapper__b5FeL"};